// Links into Naugrix (Facturier). CI writes its base URL into REACT_APP_FACTURIER_API_URL (.gitlab-ci.yml).

/** The Naugrix page of an invoice or credit note, or null when the build has no Facturier URL. */
export function facturierInvoiceUrl(
  invoiceId: number,
  base: string = process.env.REACT_APP_FACTURIER_API_URL ?? '',
): string | null {
  const root = base.trim().replace(/\/+$/, '');
  return root === '' ? null : `${root}/factures/detaille.php?ID=${invoiceId}`;
}
